export enum FeeRefundStatus {
    NonRefundable = 0,
    Refundable = 1,
    Partially = 2,
}

export const FeeRefundStatuses = [
    {
        id: FeeRefundStatus.Refundable,
        name: 'Yes',
        tooltipText: undefined,
    },
    {
        id: FeeRefundStatus.NonRefundable,
        name: 'No',
        tooltipText: undefined,
    },
    {
        id: FeeRefundStatus.Partially,
        name: 'Partially',
        tooltipText:
            'The application fee will be partially refunded in each of the following circumstances: <br>' +
            '1. 50% refund if a completed process yeilds no LOIs, <br>' +
            '2. 25% refund if a completed process yeilds ONLY 1 LOI, <br>' +
            "3. Up to 50% refund, at VetValue's discretion, depending upon the circumstances, if the engagement application is denied by VetValue",
    },
];
